import { prefixerM } from './common'

export const ROUTE_PPG_CATEGORIA = prefixerM('categoria')
export const ROUTE_PPG_MARCA = prefixerM('marca')
export const ROUTE_PPG_TIPO_PRODUCTO = prefixerM('tipo-producto')
export const ROUTE_PPG_MASTER = prefixerM('master')
export const ROUTE_PPG_CONGELACION = prefixerM('congelacion')
export const ROUTE_PPG_HIDRATACION = prefixerM('hidratacion')
export const ROUTE_PPG_LINEA_PRODUCTO = prefixerM('linea-producto')
export const ROUTE_PPG_SUBTIPO_PRODUCTO = prefixerM('subtipo-producto')
export const ROUTE_PPG_EMPAQUE = prefixerM('empaque')
export const ROUTE_PPG_ESPECIE = prefixerM('especie')
export const ROUTE_PPG_GRUPO_TALLA = prefixerM('grupo-talla')
export const ROUTE_PPG_TIPO_TALLA = prefixerM('tipo_talla')
export const ROUTE_PPG_CONDICION = prefixerM('condicion')
export const ROUTE_PPG_SUBCONDICION = prefixerM('subcondicion')
export const ROUTE_PPG_PROCESO = prefixerM('proceso')
export const ROUTE_PPG_CALIDAD = prefixerM('calidad')
export const ROUTE_PPG_SUBPROCESO = prefixerM('subproceso')
export const ROUTE_PPG_PRESENTACION = prefixerM('presentacion')
export const ROUTE_PPG_CLASIFICACION = prefixerM('clasificacion')
export const ROUTE_PPG_TALLA = prefixerM('talla')
export const ROUTE_PPG_TRATAMIENTO = prefixerM('tratamiento')
export const ROUTE_PPG_CERTIFICACION = prefixerM('certificacion')
export const ROUTE_PPG_PRODUCTO = prefixerM('producto')
